import React from 'react';

import styles from './subscribeCardStyles.scss';

const EmailSendFailure: React.FunctionComponent = ({}): React.ReactElement => {
  const mailerBody: string = encodeURIComponent(
    'Hello,\n\nI have a question related to setting up on-going access to the SumZero research database. Please reach out to me at your earliest convenience.\n\nThank you!'
  );
  const mailerSubject: string = encodeURIComponent('Question on SumZero Database Access');

  return (
    <div className={styles.error}>
      There was an issue processing your request. Please contact{' '}
      <a
        href={`mailto:access@sumzero.com?subject=${mailerSubject}&body=${mailerBody}`}
        data-heap="contact-access-email-failure"
      >
        access@sumzero.com
      </a>{' '}
      for assistance.
    </div>
  );
};

export default EmailSendFailure;
